import { createAction } from '@reduxjs/toolkit';
import { SwitchFilters } from '@store/meetings/features/filters/switch-filters';
import { IMeetingsState } from '@store/meetings/types';
import { getProfileDataSelector } from '@store/profile/selectors';
import { removeRequest } from '@utils/cancel-request';
import { sortGrowingDates } from '@utils/date-utils';
import { IMeeting } from 'lingopractices-models';
import { SagaIterator } from 'redux-saga';
import { put, select } from 'redux-saga/effects';

export class CreateMeetingSuccess {
  static get action() {
    return createAction<IMeeting>('meetings/CREATE_MEETING_SUCCESS');
  }

  static get reducer() {
    return (draft: IMeetingsState, { payload }: ReturnType<typeof CreateMeetingSuccess.action>) => {
      draft.myMeetings.meetingList = sortGrowingDates([...draft.myMeetings.meetingList, payload]);
      draft.meetings.meetingList = sortGrowingDates([...draft.meetings.meetingList, payload]);
      draft.requests.createMeetingPending = false;
      return draft;
    };
  }

  static get saga() {
    return function* (action: ReturnType<typeof CreateMeetingSuccess.action>): SagaIterator {
      const { id } = yield select(getProfileDataSelector);
      yield put(SwitchFilters.action(true));

      removeRequest(id);
    };
  }
}
